/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { TrimbleDiagnosticsControllerLookupAccountQueryResponse, TrimbleDiagnosticsControllerLookupAccountQueryParams, TrimbleDiagnosticsControllerLookupAccount400, TrimbleDiagnosticsControllerLookupAccount401, TrimbleDiagnosticsControllerLookupAccount403, TrimbleDiagnosticsControllerLookupAccount404 } from "../../models/trimbleDiagnosticsController/TrimbleDiagnosticsControllerLookupAccount";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { trimbleDiagnosticsControllerLookupAccount } from "../../clients/trimble-diagnosticsService/trimbleDiagnosticsControllerLookupAccount";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const trimbleDiagnosticsControllerLookupAccountQueryKey = (params: TrimbleDiagnosticsControllerLookupAccountQueryParams) => [{
  url: '/api/v1/trimble-account-diagnostics'
}, ...(params ? [params] : [])] as const;
export type TrimbleDiagnosticsControllerLookupAccountQueryKey = ReturnType<typeof trimbleDiagnosticsControllerLookupAccountQueryKey>;
export function trimbleDiagnosticsControllerLookupAccountQueryOptions(params: TrimbleDiagnosticsControllerLookupAccountQueryParams, config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = trimbleDiagnosticsControllerLookupAccountQueryKey(params);
  return queryOptions<TrimbleDiagnosticsControllerLookupAccountQueryResponse, ResponseErrorConfig<TrimbleDiagnosticsControllerLookupAccount400 | TrimbleDiagnosticsControllerLookupAccount401 | TrimbleDiagnosticsControllerLookupAccount403 | TrimbleDiagnosticsControllerLookupAccount404>, TrimbleDiagnosticsControllerLookupAccountQueryResponse, typeof queryKey>({
    enabled: !!params,
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return trimbleDiagnosticsControllerLookupAccount(params, config);
    }
  });
}

/**
 * @summary Resolve a Trimble IAM or CDH account link
 * {@link /api/v1/trimble-account-diagnostics}
 */
export function useTrimbleDiagnosticsControllerLookupAccount<TData = TrimbleDiagnosticsControllerLookupAccountQueryResponse, TQueryData = TrimbleDiagnosticsControllerLookupAccountQueryResponse, TQueryKey extends QueryKey = TrimbleDiagnosticsControllerLookupAccountQueryKey>(params: TrimbleDiagnosticsControllerLookupAccountQueryParams, options: {
  query?: Partial<QueryObserverOptions<TrimbleDiagnosticsControllerLookupAccountQueryResponse, ResponseErrorConfig<TrimbleDiagnosticsControllerLookupAccount400 | TrimbleDiagnosticsControllerLookupAccount401 | TrimbleDiagnosticsControllerLookupAccount403 | TrimbleDiagnosticsControllerLookupAccount404>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? trimbleDiagnosticsControllerLookupAccountQueryKey(params);
  const query = useQuery({
    ...trimbleDiagnosticsControllerLookupAccountQueryOptions(params, config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<TrimbleDiagnosticsControllerLookupAccount400 | TrimbleDiagnosticsControllerLookupAccount401 | TrimbleDiagnosticsControllerLookupAccount403 | TrimbleDiagnosticsControllerLookupAccount404>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}